import { defineMessages } from "react-intl";

export const messages = defineMessages({
  cancelOrder: {
    id: "9ZtJhn",
    defaultMessage: "Cancel order",
    description: "cancel button",
  },
  confirmOrder: {
    id: "maxT+q",
    defaultMessage: "Confirm order",
    description: "save button",
  },
  returnOrder: {
    id: "+RjQjs",
    defaultMessage: "Return / Replace order",
    description: "return button",
  },
  openGraphiQL: {
    id: "5i/InH",
    defaultMessage: "Open this order in GraphiQL",
    description: "open new window button",
  },
});
